import { UserConnectionType } from "types/black-list";

export interface Role {
  name: string;
  id: number;
}
export enum EAuthProvider {
  GOOGLE = "GOOGLE",
  TWITCH = "TWITCH",
  STEAM = "STEAM",
  DISCORD = "DISCORD",
  KICK = "KICK",
}

export const authProviderPathMap: Record<EAuthProvider, string> = {
  [EAuthProvider.GOOGLE]: "/auth/google",
  [EAuthProvider.TWITCH]: "/auth/twitch",
  [EAuthProvider.STEAM]: "/auth/steam",
  [EAuthProvider.DISCORD]: "/auth/discord",
  [EAuthProvider.KICK]: "/auth/kick",
};

export interface IUserAuthProviderDto {
  id: string;
  userId: string;
  provider: EAuthProvider;
  providerUserId: string;
  providerDisplayName: string | null;
  email: string | null;
  profileImageUrl: string | null;
  isVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IUserDto {
  id: string;
  displayName: string;
  gamdomId?: number;
  lootboxUsername?: string;
  profileImageUrl?: string;
  mfaSecret?: string;
  isBanned: boolean;
  hasVerifiedRoleOnDiscordGuild: boolean;
  banReason?: string;
  rafflesWon?: number;
  offlineImageUrl?: string;
  createdAt: string;
  pointsBalance?: number;
  pointsSpent?: number;
  viewCount?: number;
  steamTradeLink?: string;
  usdtTrc20Address?: string | null;
  usdtErc20Address?: string | null;
  btcAddress?: string | null;
  ethAddress?: string | null;
  ltcAddress?: string | null;
  email?: string;
  createdTwitchAt?: string;
  gPointsBalance?: number;
  isGPointsClaimed: boolean;
  userMultiConnections: MultiConnection[];
  authProviders: IUserAuthProviderDto[];
}

export type MultiConnection = {
  ignoreReason?: string;
  isIgnored: boolean;
  type: UserConnectionType;
  updatedAt?: Date;
  userId: string;
  value: string;
};

export enum BalanceType {
  G_POINT = "G_POINT",
  POINTS = "POINTS",
  DOLLAR = "DOLLAR",
}

export interface IUserBalanceUpdate {
  userId: string;
  balanceType: BalanceType;
  balance: number;
}

export interface ExchangeRateDto {
  point_gpoint_rate: number;
  daily_free_g_points: number;
}

export interface Guest {
  id: string;
  createdAt: string;
  pointsSpent: number;
  userId: string;
  discordId: string;
  discordUsername: string;
  isWinner: boolean;
  winDate: string | null;
  message: string;
  microphone: boolean;
  camera: boolean;
  displayName: string;
  userCreatedAt: string;
  offlineImageUrl: string;
  profileImageUrl: string;
  pointsBalance: number;
}
